export default __webpack_public_path__ + "static/media/openOutput.0260feab.png";